import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/user-roles/profile/loading';

export const Route = createFileRoute('/_private/settings/user-roles/$id')({
  pendingComponent: Loading,
});
